import { Injectable } from '@angular/core';

import { LoggerService } from './../../logger/logger.service';
import { AudioDefaultValueService } from './audio/audio-default-value.service';
import { PowerDefaultValueService } from './power/power-default-value.service';
import { CameraDefaultValueService } from './camera/camera-default-value.service';
import { DisplayDefaultValueService } from './display/display-default-value.service';
import { MicrophoneDefaultValueService } from './microphone/microphone-default-value.service';
import { IDeviceSettingsDefaultValueService } from './device-settings-default-value.interface';
import { SmartAssistDefaultValueService } from './smart-assist/smart-assist-default-value.service';

@Injectable({
	providedIn: 'root'
})
export class DeviceSettingsDefaultValueService implements IDeviceSettingsDefaultValueService {

	constructor(
		private logger: LoggerService,
		private audioDefaultValueService: AudioDefaultValueService,
		private powerDefaultValueService: PowerDefaultValueService,
		private displayDefaultValueService: DisplayDefaultValueService,
		private cameraDefaultValueService: CameraDefaultValueService,
		private microphoneDefaultValueService: MicrophoneDefaultValueService,
		private smartAssistDefaultValueService: SmartAssistDefaultValueService,
	) { }

	initialize(adTags: any): void {
		if (!adTags) {
			return;
		}

		this.logger.info('DeviceSettingsDefaultValueService - initialize adTags: ', adTags);
		this.audioDefaultValueService.initialize(adTags);
		this.powerDefaultValueService.initialize(adTags);
		this.displayDefaultValueService.initialize(adTags);
		this.cameraDefaultValueService.initialize(adTags);
		this.microphoneDefaultValueService.initialize(adTags);
		this.smartAssistDefaultValueService.initialize(adTags);
	}
}
